import { KeyboardArrowRight } from '@styled-icons/material';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';

import { VerticalList } from '~/components/Elements';
import { colors } from '~/utils/css-mixins';
import { money } from '~/utils/format';

import AtgForm from './AtgForm';

const Link = styled.a`
  color: ${colors.link};
  text-decoration: none;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const Header = styled.h3`
  font-size: 16px;
  margin-bottom: 5px;
`;

const SystemWrapper = styled.div`
  font-size: 16px;

  a {
    font-weight: 600;
  }
`;

const System = styled.div`
  margin-bottom: 1em;

  svg {
    position: relative;
    top: -1px;
    left: -4px;
  }
`;

const StyledVerticalList = styled(VerticalList)`
  font-size: 14px;
  line-height: 20px;
`;

const Info = styled.div`
  color: ${colors.textmeta};
  font-size: 14px;
  font-style: italic;
  line-height: 20px;

  a {
    border-bottom: dotted 1px ${colors.border};
    padding-bottom: 1px;
    color: inherit;

    &:focus,
    &:hover {
      color: ${colors.link};
    }
  }
`;

const V6 = styled(Info)`
  margin-top: 5px;
`;

export default class ReducedList extends PureComponent {
  static propTypes = {
    round: PropTypes.object.isRequired,
    systems: PropTypes.array.isRequired,
  };

  getCost(system) {
    if (system.cost && system.number_of_rows) {
      return (
        <span>
          : {money(system.cost, true)} ({system.number_of_rows} rader)
        </span>
      );
    }

    return null;
  }

  render() {
    const { systems } = this.props;

    return (
      <SystemWrapper>
        <div>
          {systems.map((system, i) => (
            <System key={i}>
              <Header>
                Systemförslag {i + 1}
                {this.getCost(system)}
              </Header>

              <StyledVerticalList>
                {system.jokersystem_url && (
                  <li>
                    <Link
                      href={system.jokersystem_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <KeyboardArrowRight />
                      Rätta/följ systemet lopp för lopp
                    </Link>
                  </li>
                )}
                {system.jokersystem_xml && (
                  <li>
                    <AtgForm xml={system.jokersystem_xml} />
                  </li>
                )}
              </StyledVerticalList>

              {system.v6 && <V6>Endast spel i sexrättspotten (V6)</V6>}
            </System>
          ))}
        </div>

        <Info>
          <p>
            <strong>Rätta/följ systemet lopp för lopp.</strong> Klicka på länken
            och bocka för ”Visa resultat” i nederkant för att rätta systemet
            lopp för lopp/när omgången är avslutad. Tryck på ”Översikt” för att
            se vilka hästar som är med på systemramen samt vilka reduceringskrav
            som är ställda.
          </p>
          <p>
            <strong>Lämna in via ATG.se.</strong> Direktlänk för att lämna in
            systemet på ATG.se.
          </p>
          <p>
            På{' '}
            <Link
              href="https://www.jokersystemet.se"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.jokersystemet.se
            </Link>{' '}
            kan du som har abonnemang på Jokersystemet själv öppna systemen med
            möjlighet att redigera dem. Systemen hittas under ”proffssystem”.
          </p>
          <p>
            <Link
              href="https://www.jokersystemet.se/instruktionsfilmer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tryck här för att komma till Jokersystemets instruktionsvideos.
            </Link>
          </p>
        </Info>
      </SystemWrapper>
    );
  }
}
